import { COLORS } from 'shared/constants/theme';
import themeFactory from '../helpers/themeFactory';

export default themeFactory({
  backgroundColor: COLORS.carnation,
  borderColor: COLORS.carnation,
  color: COLORS.white,
  textDecoration: 'none'
});
